<modal 
  #modalBatchDevicesUpload
  id="batch-devices-upload-modal"
  modalClass="modal-xl"
  [(errorMessage)]="_errorMessage"
  (onClose)="onModalClose()"
>
  <modal-header>Cargar Lista de {{getTabName()}}</modal-header>
  <modal-content>
    <div class="batch-registration p-2" *ngIf="currentStep === 1">
      <div class="alert alert-info mb-3">
        <i class="fas fa-info-circle"></i> 
        Sube un archivo CSV con la lista de dispositivos a los que se aplicarán acciones masivas.
        <br>El archivo puede contener hasta 1000 dispositivos.
      </div>
      
      <div class="download-section my-3 d-flex justify-content-end">
        <button class="btn btn-primary" (click)="downloadSampleFile()">
          <i class="fas fa-download"></i> {{_appService.CoreCommonLiterals.DownloadSampleCSV}}
        </button>
      </div>
      
      <div *ngIf="!fileSelected" class="text-center my-3">
        <div class="upload-container" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <input type="file" id="fileInput" #fileInput (change)="onFileSelected($event)" accept=".csv" hidden />
          <label for="fileInput" class="upload-area">
            <i class="fa-solid fa-cloud-arrow-up fa-3x text-muted d-block mb-2"></i>
            <button class="btn border mb-2" (click)="fileInput.click()">{{_appService.CoreCommonLiterals.ChooseFileToUpload | replaceLiterals:['CSV']}}</button>
            <p class="text-muted" style="font-size: 12px;">{{_appService.CoreCommonLiterals.DragAndDropMessage}}</p>
          </label>
        </div>
      </div>
      
      <div *ngIf="isLoading" class="text-center my-3 d-flex align-items-center justify-content-center" style="min-height: 230px;">
        <div class="spinner-border text-primary" role="status">
          <span class="sr-only">{{_appService.CoreCommonLiterals.Loading}}...</span>
        </div>
      </div>
    
      <div *ngIf="fileSelected && !isLoading" class="file-details text-center p-4 border rounded shadow-sm d-flex flex-column align-items-center">
        <i class="fas fa-file-csv fa-3x text-success mb-2"></i>
        <h6 class="mt-2 text-muted">{{_appService.CoreCommonLiterals.SelectedFile}}</h6>
        <p class="font-weight-bold">{{ fileName }}</p>
        <div class="d-flex gap-2 mt-3">
          <button class="btn btn-outline-danger" (click)="clearFile()">
            <i class="fa-solid fa-eraser"></i> {{_appService.CoreCommonLiterals.ButtonClean}}
          </button>
        </div>
      </div>
    </div>
    
    <div *ngIf="currentStep === 2">
      <div id="containerTable" #containerTable class="table-responsive px-2">
        <p style="font-size: 20px;" class="font-weight-bold">{{_appService.CoreCommonLiterals.DataPreview}}</p>
        <p class="text-muted mb-3">Se cargarán {{loadedDeviceIds.length}} dispositivos únicos</p>
      
        <table id="tableCmp" #tableCmp class="table table-hover tablestuff">
          <thead class="frozen my-3">
            <tr>
              <th *ngFor="let header of tableHeaders; let i = index" 
                class="report-cell border-bottom-1" 
                style="height: 50px; background: #f2f4f6;" 
                [ngStyle]="getColumnWidth(i, header)">
                <div class="report-cell-content text-nowrap">
                  {{header.title}}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of paginatedTableData; let i = index; trackBy: trackByIndex" 
              class="table-results position-relative" 
              [ngClass]="{'table-striped': i % 2 === 0}">
              <td *ngFor="let cell of row; let j = index; trackBy: trackByCellIndex" class="position-relative p-1">
                <div class="report-cell-content d-flex align-items-center position-relative">
                  <input type="text" 
                    [(ngModel)]="paginatedTableData[i][j]" 
                    class="form-control" 
                    [ngClass]="{'border-info': !hasValidationError(i, j) || paginatedTableData[i][j], 'border-danger': hasValidationError(i, j) }" 
                    (ngModelChange)="onCellEdit(i, j, $event)"
                    [required]="tableHeaders[j]?.key === 'DeviceID'"/>
                  
                  <div *ngIf="hasValidationError(i, j)" class="error-message text-danger" style="font-size: 0.75em; margin-top: 0.25rem;">
                    <i class="fas fa-exclamation-circle"></i> {{getValidationError(i, j)}}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      
        <div class="not-found-message text-center mt-5" *ngIf="tableData && tableData.length === 0">
          <i class="fa fa-file-alt fa-3x text-primary"></i>
          <p class="mt-3">{{_appService.CoreCommonLiterals.NoDataFound}}</p>
        </div>
        
        <div class="pagination-controls mb-2 d-flex justify-content-center mt-3">
          <button class="btn btn-secondary" *ngIf="totalPages > 3" [disabled]="currentPage === 1" (click)="onPageChange(1)">
            {{_appService.CoreCommonLiterals.FirstPage}}
          </button>
          <button class="btn btn-secondary mx-2" [disabled]="currentPage === 1" (click)="previousPage()">
            {{_appService.CoreCommonLiterals.PreviousPage}}
          </button>
          <span class="mx-2 d-flex align-items-center"> {{currentPage}} / {{totalPages}}</span>
          <button class="btn btn-secondary mx-2" [disabled]="currentPage === totalPages" (click)="nextPage()">
            {{_appService.CoreCommonLiterals.NextPage}}
          </button>
          <button class="btn btn-secondary" *ngIf="totalPages > 3" [disabled]="currentPage === totalPages" (click)="onPageChange(-2)">
            {{_appService.CoreCommonLiterals.LastPage}}
          </button>
        </div>
      </div>
    </div>
  </modal-content>
  <modal-footer>
    <a id="modal-upload-btn-cancel" class="btn btn-secondary mr-3" *ngIf="currentStep !== 2" (click)="onModalClose()">{{_appService.CoreCommonLiterals.ButtonCancel}}</a>
    <a id="modal-upload-btn-back" *ngIf="currentStep === 2" class="btn btn-secondary" (click)="currentStep = 1; clearFile()">{{_appService.CoreCommonLiterals.GoBack}}</a>
    <a id="modal-upload-btn-next" *ngIf="currentStep === 1" class="btn btn-primary" [ngClass]="{'isDisabled': _errorMessage || !_enableNextButton}" (click)="proceedToNextStep()">{{_appService.CoreCommonLiterals.Next}}</a>
    <a id="modal-upload-btn-confirm" *ngIf="currentStep === 2" class="btn btn-primary ml-3" (click)="onConfirmLoad()" [ngClass]="{'isDisabled': validationErrors.length > 0}">{{_appService.CoreCommonLiterals.ButtonConfirm}}</a>
  </modal-footer>
</modal>

